import { checkUserPermissions } from '@/services/auth';
import { getLocalUser } from '@/services/session-data';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
import { ACCESS_TYPE_EMEDE } from '@/settings/consts/users';
//import Dashboard from './index.vue';
const Dashboard = () => import('./index.vue')
const PatientsPrescrMonitoringyTable = () => import('./patient-prescr-monitoring-table.vue')

export const dashboardRoutes = [];
export const DASHBOARD_PATIENTS_MONITORING_PATH = '/dashboard/pacientes/prescricoes/acompanhamento';

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.DASHBOARD_ADMIN
  ])
) {
  dashboardRoutes.push({
    path: '/dashboard/admin',
    name: 'Dashboard|Dashboard Admin',
    component: Dashboard,
    meta: {
      icon: 'fa-bar-chart',
      requiresAuth: true,
    },
  });
}


if (
  checkUserPermissions([
    PERMISSIONS_KEYS.MONITORING_PATIENT
  ])
) {
  getLocalUser().subscribe(res => {
    if (res.tipoAcesso !== ACCESS_TYPE_EMEDE) {
      return
    }
    dashboardRoutes.push({
      path: DASHBOARD_PATIENTS_MONITORING_PATH,
      name: 'Dashboard|Acompanhamento de Paciente',
      component: PatientsPrescrMonitoringyTable,
      meta: {
        icon: 'fa-bar-chart',
        requiresAuth: true,
      },
    });
  });
}




